export default __webpack_public_path__ + "static/media/bg-test-access-light.00f86f8c.jpg";